export interface Country {
  code: string;
  label: string;
  region: string;
  phone_code?: string; // Optional, will be populated dynamically
  phone_codes?: string[];
  // default_phone_code?: string;
}

// Asian countries with common phone codes as fallback
export const asianCountriesFallback: Country[] = [
  { code: 'AF', label: 'Afghanistan', region: 'Southern Asia', phone_code: '+93' },
  { code: 'AM', label: 'Armenia', region: 'Western Asia', phone_code: '+374' },
  { code: 'AZ', label: 'Azerbaijan', region: 'Western Asia', phone_code: '+994' },
  { code: 'BH', label: 'Bahrain', region: 'Western Asia', phone_code: '+973' },
  { code: 'BD', label: 'Bangladesh', region: 'Southern Asia', phone_code: '+880' },
  { code: 'BT', label: 'Bhutan', region: 'Southern Asia', phone_code: '+975' },
  { code: 'BN', label: 'Brunei', region: 'Southeast Asia', phone_code: '+673' },
  { code: 'KH', label: 'Cambodia', region: 'Southeast Asia', phone_code: '+855' },
  { code: 'CN', label: 'China', region: 'Eastern Asia', phone_code: '+86', phone_codes: ['+86', '+852', '+853', '+886'] },
  { code: 'CY', label: 'Cyprus', region: 'Western Asia', phone_code: '+357' },
  { code: 'GE', label: 'Georgia', region: 'Western Asia', phone_code: '+995' },
  { code: 'HK', label: 'Hong Kong', region: 'Eastern Asia', phone_code: '+852' },
  { code: 'IN', label: 'India', region: 'Southern Asia', phone_code: '+91' },
  { code: 'ID', label: 'Indonesia', region: 'Southeast Asia', phone_code: '+62' },
  { code: 'IR', label: 'Iran', region: 'Southern Asia', phone_code: '+98' },
  { code: 'IQ', label: 'Iraq', region: 'Western Asia', phone_code: '+964' },
  { code: 'IL', label: 'Israel', region: 'Western Asia', phone_code: '+972' },
  { code: 'JP', label: 'Japan', region: 'Eastern Asia', phone_code: '+81' },
  { code: 'JO', label: 'Jordan', region: 'Western Asia', phone_code: '+962' },
  { code: 'KZ', label: 'Kazakhstan', region: 'Central Asia', phone_code: '+7' },
  { code: 'KW', label: 'Kuwait', region: 'Western Asia', phone_code: '+965' },
  { code: 'KG', label: 'Kyrgyzstan', region: 'Central Asia', phone_code: '+996' },
  { code: 'LA', label: 'Laos', region: 'Southeast Asia', phone_code: '+856' },
  { code: 'LB', label: 'Lebanon', region: 'Western Asia', phone_code: '+961' },
  { code: 'MY', label: 'Malaysia', region: 'Southeast Asia', phone_code: '+60' },
  { code: 'MV', label: 'Maldives', region: 'Southern Asia', phone_code: '+960' },
  { code: 'MN', label: 'Mongolia', region: 'Eastern Asia', phone_code: '+976' },
  { code: 'MM', label: 'Myanmar', region: 'Southeast Asia', phone_code: '+95' },
  { code: 'NP', label: 'Nepal', region: 'Southern Asia', phone_code: '+977' },
  { code: 'KP', label: 'North Korea', region: 'Eastern Asia', phone_code: '+850' },
  { code: 'OM', label: 'Oman', region: 'Western Asia', phone_code: '+968' },
  { code: 'PK', label: 'Pakistan', region: 'Southern Asia', phone_code: '+92' },
  { code: 'PS', label: 'Palestine', region: 'Western Asia', phone_code: '+970' },
  { code: 'PH', label: 'Philippines', region: 'Southeast Asia', phone_code: '+63' },
  { code: 'QA', label: 'Qatar', region: 'Western Asia', phone_code: '+974' },
  { code: 'SA', label: 'Saudi Arabia', region: 'Western Asia', phone_code: '+966' },
  { code: 'SG', label: 'Singapore', region: 'Southeast Asia', phone_code: '+65' },
  { code: 'KR', label: 'South Korea', region: 'Eastern Asia', phone_code: '+82' },
  { code: 'LK', label: 'Sri Lanka', region: 'Southern Asia', phone_code: '+94' },
  { code: 'SY', label: 'Syria', region: 'Western Asia', phone_code: '+963' },
  { code: 'TW', label: 'Taiwan', region: 'Eastern Asia', phone_code: '+886' },
  { code: 'TJ', label: 'Tajikistan', region: 'Central Asia', phone_code: '+992' },
  { code: 'TH', label: 'Thailand', region: 'Southeast Asia', phone_code: '+66' },
  { code: 'TL', label: 'Timor-Leste', region: 'Southeast Asia', phone_code: '+670' },
  { code: 'TR', label: 'Turkey', region: 'Western Asia', phone_code: '+90' },
  { code: 'TM', label: 'Turkmenistan', region: 'Central Asia', phone_code: '+993' },
  { code: 'AE', label: 'United Arab Emirates', region: 'Western Asia', phone_code: '+971' },
  { code: 'UZ', label: 'Uzbekistan', region: 'Central Asia', phone_code: '+998' },
  { code: 'VN', label: 'Vietnam', region: 'Southeast Asia', phone_code: '+84' },
  { code: 'YE', label: 'Yemen', region: 'Western Asia', phone_code: '+967' }
];